import { inject } from "@angular/core";
import { patchState, signalStoreFeature, type, withMethods } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { tapResponse } from "@ngrx/operators";
import { IUserProfileState } from "./user-profile.state";
import { exhaustMap, pipe, tap } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { UserProfile } from "../../models/user-profile/user-profile.model";
import { withUserProfileStateMethods } from "./user-profile.methods.state";
import { NotificationService } from "../../services/notification/notification.service";
import { UserProfileService } from "../../services/user-profile/user-profile.service";

export const withUserProfileApiMethods = signalStoreFeature(
    { state: type<IUserProfileState>() },
    withUserProfileStateMethods,
    withMethods((store) => {
        const userProfileService = inject(UserProfileService);
        const notificationService = inject(NotificationService);

        const loadProfile = rxMethod<void>(
            pipe(
                tap(() => patchState(store, { loading: true, error: null })),
                exhaustMap(() =>
                    userProfileService.getProfile().pipe(
                        tapResponse({
                            next: (userProfile: UserProfile) => store.setUserProfile(userProfile),
                            error: (error: HttpErrorResponse) => {
                                store.setError(error.message);
                                notificationService.notifyError("Error", error.message);
                            }
                        })
                    )
                )
            )
        );

        const loadProfileByGuid = rxMethod<string>(
            pipe(
                tap(() => patchState(store, { loading: true, error: null })),
                exhaustMap((userProfileGuid) =>
                    userProfileService.getProfileByGuid(userProfileGuid).pipe(
                        tapResponse({
                            next: (userProfile: UserProfile) => store.setUserProfile(userProfile),
                            error: (error: HttpErrorResponse) => {
                                store.setError(error.message);
                                notificationService.notifyError("Error", error.message);
                            }
                        })
                    )
                )
            )
        );

        return { loadProfile, loadProfileByGuid };
    })
);
